<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>后台充值管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="手机号:">
        <el-input size="small" v-model="formInline.tel" placeholder="输入手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="getdata()">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">充值</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="id" label="序号" >
      </el-table-column>
      <el-table-column sortable prop="tel" label="手机号" >
      </el-table-column>
      <el-table-column sortable prop="money" label="充值金额（元）" >
        <template slot-scope="scope" >
          {{ scope.row.money/100 }}
        </template>
      </el-table-column>
      <el-table-column sortable prop="create_time" label="时间" >
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="手机号" prop="tel">
          <el-input size="small" v-model="editForm.tel"  placeholder="请输入充值金额"></el-input>
        </el-form-item>
        <el-form-item label="充值金额 ( 元 )" prop="money">
          <el-input size="small" v-model="editForm.money"  placeholder="请输入充值金额"></el-input>
        </el-form-item>
        <!-- <el-form-item label="专属场地" prop="exclusive_field_id">
          <el-select v-model="editForm.exclusive_field_id" placeholder="请选择场地名称" v-if="editForm.is_general == 0">
            <el-option v-for="item in station_names" :label="item.station_name" :value="item.id" :key="item.id"></el-option>
          </el-select>
          <el-input size="small"  placeholder="卡片类型为专属卡片时，必填" v-if="editForm.is_general != 0" disabled></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getStationNames} from '../../api/station'

import { getBackendFeeLog,addBackendFee} from '../../api/money'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      station_names:[],
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        tel: '',
        money: '',
      },
      status_names:[{name:'启用',val:1},{name:'停用',val:0}],
      // rules表单验证
      rules: {
        tel: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        money:  [
            {  required: true, message: '充值金额', trigger: 'blur' },
            {
                validator: (rule, value, callBack) => {
                    if(value <= 0){
                        callBack('充值金额不能小于0')
                    }else{
                        callBack()
                    }
                }
            }
        ]
      },
      formInline: {
        page: 1,
        limit: 10,
        tel: '',
        income:3
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getStationNames()
    this.getdata()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getStationNames(){
      getStationNames().then(res => {
        if (res.code == 0) {
            this.station_names = res.data
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },
    // 获取公司列表
    getdata() {
      this.loading = true
      getBackendFeeLog(this.formInline).then(res => {
          this.loading = false
          this.listData = res.data.data
          this.pageparm.currentPage = res.data.current_page
          this.pageparm.pageSize = res.data.per_page
          this.pageparm.total = res.data.total

      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
        this.title = '添加'
        this.editForm =  {
          tel: '',
          money: '',
        }

    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          addBackendFee(this.editForm)
          .then(res => {
            this.editFormVisible = false
            this.loading = false
            if (res.code ==0) {
              this.getdata(this.formInline)
              this.$message({
                type: 'success',
                message: '添加成功！'
              })
            } else {
              this.$message({
                type: 'info',
                message: res.message
              })
            }
          })
          .catch(err => {
            this.editFormVisible = false
            this.loading = false
            this.$message.error('添加失败，请稍后再试！')
          })
        }
      })
      },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/backend/Backend.vue